module.exports = __webpack_public_path__ + "static/media/06- user-denied.05132e6d.png";